<template>
	<v-card
		flat
		width="500px"
	>
		<v-card-title class="secondary--text">
			<span>Filtri</span>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-text>
			<v-row v-if="!hideClientiFilter" class="mt-1">
				<v-col>
					<v-autocomplete
						v-model="computedClientiIds"
						:items="clienti"
						label="Clienti"
						:loading="isLoadingClienti"
						:disabled="isLoadingClienti"
						item-value="id"
						item-text="cognome_nome_ragione_sociale_tipologia"
						multiple
						small-chips
						clearable
						deletable-chips
						outlined
						dense
					></v-autocomplete>
				</v-col>
			</v-row>
			
			<v-row class="mt-0">
				<v-col>
					<v-select
						v-model="computedEsitoClickDay"
						:items="tipiEsito"
						label="Esito Click Day"
						clearable
						outlined
						dense
					></v-select>
				</v-col>
			</v-row>
			
			<v-row class="mt-0">
				<v-col>
					<v-select
						v-model="computedDataScadenzaSaldoEsitiProvvisori"
						:items="tipiDataScadenzaSaldoEsitiProvvisori"
						label="Data Scadenza Saldo Esiti Provvisori"
						clearable
						outlined
						dense
					></v-select>
				</v-col>
			</v-row>
			
			<v-row class="mt-0">
				<v-col>
					<v-select
						v-model="computedDataScadenzaSaldoEsitiDefinitivi"
						:items="tipiDataScadenzaSaldoEsitiDefinitivi"
						label="Data Scadenza Saldo Esiti Definitivi"
						clearable
						outlined
						dense
					></v-select>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-btn
				@click="resetFilters()"
				color="info"
			>
				Azzera filtri
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				@click="closeDialog()"
				color="tertiary"
				class="black--text"
			>
				Annulla
			</v-btn>
			<v-btn
				@click="applyFilters()"
				color="secondary"
				:disabled="isLoading"
			>
				Filtra
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {eventBus} from "@/event-bus";
import {mapActions, mapGetters, mapMutations} from "vuex";
export default {
	props: {
		hideClientiFilter: {
			default: false
		},
		// accountManagersIds: {
		// 	default: null
		// }
	},
	data() {
		return {
			isLoadingClienti: false,
			clienti: [],
			
			tipiEsito: [
				'Almeno un vincente',
				'Nessun vincente'
			],
			
			tipiDataScadenzaSaldoEsitiProvvisori: [
				'Senza data scadenza saldo esiti provvisori',
				'Con data scadenza saldo esiti provvisori'
			],
			
			tipiDataScadenzaSaldoEsitiDefinitivi: [
				'Senza data scadenza saldo esiti definitivi',
				'Con data scadenza saldo esiti definitivi'
			],
		}
	},
	
	created() {
		this.getClienti();
	},
	
	computed: {
		...mapGetters({
			clientiIds: 'contrattiDiServizioFilters/clientiIds',
			esitoClickDay: 'contrattiDiServizioFilters/esitoClickDay',
			dataScadenzaSaldoEsitiProvvisori: 'contrattiDiServizioFilters/dataScadenzaSaldoEsitiProvvisori',
			dataScadenzaSaldoEsitiDefinitivi: 'contrattiDiServizioFilters/dataScadenzaSaldoEsitiDefinitivi',
			defaultFilters: 'contrattiDiServizioFilters/defaultFilters'
		}),
		computedClientiIds: {
			get: function () {
				return this.clientiIds.value;
			},
			set: function (value) {
				if (value?.length === 0) value = null;
				this.setClientiIdsNotApplied(value);
			}
		},
		computedEsitoClickDay: {
			get: function () {
				return this.esitoClickDay.value;
			},
			set: function (value) {
				this.setEsitoClickDayNotApplied(value);
			}
		},
		computedDataScadenzaSaldoEsitiProvvisori: {
			get: function () {
				return this.dataScadenzaSaldoEsitiProvvisori.value;
			},
			set: function (value) {
				this.setDataScadenzaSaldoEsitiProvvisoriNotApplied(value);
			}
		},
		computedDataScadenzaSaldoEsitiDefinitivi: {
			get: function () {
				return this.dataScadenzaSaldoEsitiDefinitivi.value;
			},
			set: function (value) {
				this.setDataScadenzaSaldoEsitiDefinitiviNotApplied(value);
			}
		},
		isLoading() {
			return this.isLoadingClienti;
		}
	},
	
	methods: {
		...mapMutations({
			setClientiIdsNotApplied: 'contrattiDiServizioFilters/SET_CLIENTI_IDS_NON_APPLIED',
			setEsitoClickDayNotApplied: 'contrattiDiServizioFilters/SET_ESITO_CLICK_DAY_NON_APPLIED',
			setDataScadenzaSaldoEsitiProvvisoriNotApplied: 'contrattiDiServizioFilters/SET_DATA_SCADENZA_SALDO_ESITI_PROVVISORI_NON_APPLIED',
			setDataScadenzaSaldoEsitiDefinitiviNotApplied: 'contrattiDiServizioFilters/SET_DATA_SCADENZA_SALDO_ESITI_DEFINITIVI_NON_APPLIED'
		}),
		...mapActions({
			applyFiltersAction: 'contrattiDiServizioFilters/applyFilters',
			resetFiltersAction: 'contrattiDiServizioFilters/resetFilters',
		}),
		getClienti() {
			this.isLoadingClienti = true;
			axios.get('/api/clienti', {
				params: {
					order_by: 'cognome'
				}
			})
				.then(response => {
					this.clienti = response.data;
				})
				.finally(() => {
					this.isLoadingClienti = false;
				})
		},
		applyFilters() {
			this.applyFiltersAction();
			this.$emit('reload-contratti-di-servizio');
			this.closeDialog();
		},
		resetFilters(withoutApply = false) {
			this.resetFiltersAction();
			this.$emit('reload-contratti-di-servizio');
			this.closeDialog();
		},
		closeDialog() {
			this.$emit('close');
		}
	}
}
</script>

<style scoped>

</style>